import script from "./BuyerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerModal.vue?vue&type=script&setup=true&lang=js"

import "./BuyerModal.vue?vue&type=style&index=0&id=809d74c6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-809d74c6"]])

export default __exports__